import { MINIMAX_TYPES } from '@/constants';
import get from 'get-object-path';

export const importedFileEdit = {
    namespaced: true,

    state: {
        initialFile: null,
        pieces: [],
        selectedPiece: null,
        selectedTypes: [MINIMAX_TYPES[0], MINIMAX_TYPES[1], MINIMAX_TYPES[2]],
        infoModalFile: null,
        infoModalTelemetryFile: null
    },

    getters: {
        firstPositionTimestamp(state) {
            return get(state, 'initialFile.session_info.start_time');
        },

        initialFile(state) {
            return state.initialFile;
        },

        pieces(state) {
            return state.pieces;
        },

        selectedPiece(state) {
            return state.selectedPiece;
        },

        selectedTypes(state) {
            return state.selectedTypes;
        },

        selectedInfoFile(state) {
            return state.infoModalFile;
        },

        selectedInfoTelemetryFile(state) {
            console.log('selectedInfoTelemetryFile', state.infoModalTelemetryFile);
            return state.infoModalTelemetryFile;
        }
    },

    mutations: {
        resetState(state) {
            state.pieces = [];
            state.selectedPiece = null;
        },

        resetInitialFile(state) {
            state.initialFile = null;
        },

        setInitialFile(state, file) {
            if (!state.initialFile) {
                state.initialFile = file;
            }
        },

        selectPiece(state, piece) {
            state.selectedPiece = piece;
        },

        setPieces(state, pieces) {
            state.pieces = pieces;
        },

        setSelectedTypes(state, selectedTypes) {
            state.selectedTypes = selectedTypes;
        },

        setInfoModalFile(state, file) {
            state.infoModalFile = file;
        },

        setInfoModalTelemetryFile(state, telemetryFile) {
            state.infoModalTelemetryFile = telemetryFile;
        }
    }
};

export default importedFileEdit;
